import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["id"],
  _excluded2 = ["id", "mountContainer", "config", "pluginConfig", "autoTrigger", "formSchema"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getAESPluginSurveyCore from '@ali/aes-tracker-plugin-survey-core';
import { AESPluginUILoaded, cloneObj, createMask, getPluginUI, getUIInstanceForClose, isPromiseSupported, loadPlugin, onHrefChange } from './utils';
import pkgJson from '../package.json';
var _ref = pkgJson || {},
  currentVersion = _ref.version;
var PreviewDataKey = 'plugin-survey-preview-data';
var isPreviewing = false;
var toVoid = function toVoid() {};
var defaultHooks = {
  onOpen: toVoid,
  onSubmit: toVoid,
  onRefuse: toVoid,
  onClose: toVoid,
  onSurveyMounted: toVoid,
  onNextMonthChange: toVoid
};
function AESPluginSurvey(aes) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!isPromiseSupported) {
    return console.log('tracker-plugin：当前环境不支持promise');
  }
  var _config = aes.getConfig() || {};
  var pid = _config.plugin_survey && _config.plugin_survey.pid || _config.pid;
  // const { pid } = aes.getConfig();

  // init config & surveyCore for all other methods
  var surveyConfig = _objectSpread(_objectSpread(_objectSpread({}, aes.getConfig('plugin_survey')), config), {}, {
    pid: pid
  }); // append pid to surveyConfig
  var surveyCore = getAESPluginSurveyCore(aes, surveyConfig);
  init(surveyCore, surveyConfig);
  onHrefChange(function () {
    init(surveyCore, surveyConfig);
  });
  return {
    openSurvey: openSurveyWraper({
      surveyConfig: surveyConfig,
      surveyCore: surveyCore
    }),
    closeSurvey: closeSurveyWraper({
      surveyConfig: surveyConfig
    }),
    renderEmbed: renderEmbedWraper({
      surveyConfig: surveyConfig,
      surveyCore: surveyCore
    }),
    destoryEmbed: closeSurveyWraper({
      surveyConfig: surveyConfig
    }),
    getSchemaById: getSchemaByIdWraper({
      surveyCore: surveyCore
    })
  };
}
export default AESPluginSurvey;
function init(surveyCore, surveyConfig) {
  var pid = surveyConfig.pid,
    notAutoSend = surveyConfig.notAutoSend;
  if (!pid || notAutoSend) return false;

  // prepare localStorage
  surveyCore.utils.init().then(function () {
    // check if is preview
    if (isPreviewing) return;
    surveyCore.utils.getStorage(PreviewDataKey).then(function (previewDatas) {
      var now = Date.now();
      var previewTarget = (previewDatas || []).filter(function (x) {
        return (x === null || x === void 0 ? void 0 : x.date) > now;
      }).find(function (x) {
        return location.href.indexOf(x === null || x === void 0 ? void 0 : x.href) != -1;
      });
      if (previewTarget) {
        isPreviewing = true;
        return previewInit({
          previewData: previewTarget,
          pid: pid,
          surveyCore: surveyCore,
          surveyConfig: surveyConfig
        });
      }
      Promise.all([surveyCore.getSchema({}), getPluginUI(pid)]).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          schema = _ref3[0],
          ui = _ref3[1];
        if (!schema || !ui) return false;

        // mount ui
        if (ui !== null && ui !== void 0 && ui.hasOpen(schema.id, true)) {
          console.log('有插件已打开.', schema.id);
          return;
        }
        var options = {
          initOpen: true,
          currentVersion: currentVersion
        };
        return _load({
          schema: schema,
          options: options,
          surveyCore: surveyCore,
          surveyConfig: surveyConfig
        });
      });
    });
  }).catch(function (e) {
    console.log('不弹问卷');
  });
}
function _load(_ref4) {
  var schema = _ref4.schema,
    options = _ref4.options,
    surveyCore = _ref4.surveyCore,
    surveyConfig = _ref4.surveyConfig;
  function _onSurveyMounted() {
    if (typeof options.onSurveyMounted === 'function') {
      options.onSurveyMounted(false);
    } else if (options.onSurveyMounted) {
      console.error('onSurveyMounted属性类型错误，需要是函数类型');
    }
  }

  // @ts-ignore
  var _ref5 = surveyConfig || {},
    pid = _ref5.pid;
  return getPluginUI(pid).then(function (ui) {
    if (AESPluginUILoaded && schema) {
      return ui.loadUI({
        formSchema: cloneObj(schema),
        options: options,
        surveyConfig: surveyConfig
      }, surveyCore.utils);
    } else {
      _onSurveyMounted();
    }
  });
}
var isPreviewSuccess = false;
function previewInit(_ref6) {
  var previewData = _ref6.previewData,
    pid = _ref6.pid,
    surveyCore = _ref6.surveyCore,
    surveyConfig = _ref6.surveyConfig;
  if (isPreviewSuccess) return;
  var previewId = previewData.id,
    previewPid = previewData.pid;
  var options = {
    mountContainer: null,
    loadForce: true,
    currentVersion: currentVersion
  };
  var stopPreview = function stopPreview() {
    surveyCore.utils.setStorage(PreviewDataKey, []);
    window.location.reload();
  };
  if (previewPid !== pid) {
    return createMask("\u76EE\u6807\u5730\u5740\u4E0D\u5C5E\u4E8E\u5F53\u524D\u9879\u76EE\uFF0C\u9884\u89C8\u5931\u6548 ", stopPreview);
  }
  Promise.all([surveyCore.getDraftSchema({
    id: previewId
  }), loadPlugin()]).then(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 1),
      schema = _ref8[0];
    if (!schema) {
      return createMask("\u672A\u83B7\u53D6\u5230\u63D2\u4EF6\u914D\u7F6E\uFF0C\u8BF7\u4FDD\u5B58\u540E\u518D\u9884\u89C8 ", stopPreview);
    }
    _load({
      schema: schema,
      options: options,
      surveyCore: surveyCore,
      surveyConfig: surveyConfig
    });
    createMask("\u5F53\u524D\u5904\u4E8E\u8BC4\u5206\u63D2\u4EF6\uFF08ID\uFF1A".concat(previewId, "\uFF09\u9884\u89C8\u72B6\u6001 "), stopPreview);
  });
}

// 脚本打开插件
function openSurveyWraper(_ref9) {
  var surveyConfig = _ref9.surveyConfig,
    surveyCore = _ref9.surveyCore;
  return function (props) {
    // autoTrigger 默认false，不启用
    var id = props.id,
      autoTrigger = props.autoTrigger;
    var options = _objectSpread(_objectSpread({
      mountContainer: null,
      loadForce: true,
      currentVersion: currentVersion
    }, defaultHooks), props);
    return Promise.all([surveyCore.getSchema({
      id: id,
      autoTrigger: autoTrigger
    }), loadPlugin()]).then(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
        schema = _ref11[0];
      _load({
        schema: schema,
        options: options,
        surveyConfig: surveyConfig,
        surveyCore: surveyCore
      });
    }).catch(function (error) {
      return false;
    });
  };
}

// 关闭插件
function closeSurveyWraper(_ref12) {
  var surveyConfig = _ref12.surveyConfig;
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = props.id,
      rest = _objectWithoutProperties(props, _excluded);
    var pid = surveyConfig.pid;
    getUIInstanceForClose(pid).then(function (ui) {
      if (ui) {
        ui === null || ui === void 0 || ui.destoryUI(id, rest);
      }
    });
  };
}
function renderEmbedWraper(_ref13) {
  var surveyConfig = _ref13.surveyConfig,
    surveyCore = _ref13.surveyCore;
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = props.id,
      mountContainer = props.mountContainer,
      config = props.config,
      pluginConfig = props.pluginConfig,
      autoTrigger = props.autoTrigger,
      _props$formSchema = props.formSchema,
      formSchema = _props$formSchema === void 0 ? null : _props$formSchema,
      rest = _objectWithoutProperties(props, _excluded2);
    if (!mountContainer) {
      console.error('mountContainer 不能为空');
      return;
    }
    var options = _objectSpread(_objectSpread({
      mountContainer: mountContainer,
      loadForce: true,
      config: config,
      pluginConfig: pluginConfig,
      currentVersion: currentVersion
    }, defaultHooks), rest);
    return Promise.all([formSchema || surveyCore.getSchema({
      id: props.id,
      autoTrigger: autoTrigger
    }), loadPlugin()]).then(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 1),
        schema = _ref15[0];
      return _load({
        schema: schema,
        options: options,
        surveyCore: surveyCore,
        surveyConfig: surveyConfig
      });
    });
  };
}
function getSchemaByIdWraper(_ref16) {
  var surveyCore = _ref16.surveyCore;
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = props.id;
    if (!id) return Promise.reject('请输入id');
    return surveyCore.getSchema({
      id: props.id,
      autoTrigger: false
    }).then(function (schema) {
      return cloneObj(schema);
    });
  };
}